import { initBg } from './bg';

export function initNewsFilter() {

  const form = document.querySelector('[data-news-filter]');
  if (!form) return;

  const ajaxUrl    = form.dataset.ajaxUrl;
  const nonce      = form.dataset.nonce;
  const results    = document.querySelector('[data-news-results]');
  const grid       = results?.querySelector('[data-news-grid]');
  const pagination = results?.querySelector('[data-news-pagination]');
  const resetBtn   = form.querySelector('[data-reset="filters"]');

  if (!ajaxUrl || !grid || !pagination) return;

  let currentPaged = parseInt(new URLSearchParams(location.search).get('paged'), 10) || 1;
  let inflight     = null;

  const buildParams = () => {
    const data = new FormData(form);
    data.append('action', 'utem_filter_news');
    data.append('nonce', nonce);
    data.append('paged', String(currentPaged));
    return data;
  };

  const syncUrl = () => {
    const params = new URLSearchParams();
    new FormData(form).forEach((v, k) => { if (v) params.set(k, v); });
    if (currentPaged > 1) params.set('paged', String(currentPaged));

    const qs = params.toString();
    const newUrl = location.pathname + (qs ? '?' + qs : '');
    history.pushState({}, '', newUrl);
  };

  const fetchResults = async () => {

    if (inflight) inflight.abort();
    inflight = new AbortController();

    results.classList.add('_loading');

    try {

      const res = await fetch(ajaxUrl, {
        method: 'POST',
        body: buildParams(),
        credentials: 'same-origin',
        signal: inflight.signal
      });

      const json = await res.json();

      if (json && json.success) {
        grid.innerHTML = json.data.html || '';
        pagination.innerHTML = json.data.pagination || '';
        initBg(grid);
        syncUrl();
      }

    } catch (err) {
      if (err.name !== 'AbortError') console.error(err);
    } finally {
      results.classList.remove('_loading');
      inflight = null;
    }

  };

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    currentPaged = 1;
    fetchResults();
  });

  form.querySelectorAll('select').forEach(select => {
    select.addEventListener('change', () => {
      currentPaged = 1;
      fetchResults();
    });
  });

  if (resetBtn) {
    resetBtn.addEventListener('click', () => {
      form.querySelectorAll('select').forEach(s => { s.value = ''; });
      currentPaged = 1;
      fetchResults();
    });
  }

  pagination.addEventListener('click', (e) => {

    const link = e.target.closest('a.page-numbers');
    if (!link) return;

    e.preventDefault();

    const hrefParams = new URLSearchParams((link.getAttribute('href') || '').split('?')[1] || '');
    const next = parseInt(hrefParams.get('paged'), 10) || 1;

    currentPaged = next;
    fetchResults();

    const offset = 120;
    const top = results.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top, behavior: 'smooth' });

  });

  window.addEventListener('popstate', () => {

    const params = new URLSearchParams(location.search);
    form.querySelectorAll('select').forEach(s => {
      s.value = params.get(s.name) || '';
    });
    currentPaged = parseInt(params.get('paged'), 10) || 1;
    fetchResults();

  });

}
